import {isEmail, trim} from "validator";

const INVALID_STRING = { error: true, value: "" };

export const validators = {

  email(email: string | null) {
    if (!email) email = "";
    if (isEmail(email)) {
      return {
        error: false,
        value: trim(email),
      };
    }
    return INVALID_STRING;
  },

  password(value: string | null) {
    if (!value) value = "";
    if (value.length >= 5 && value.length <= 1024) {
      return {
        error: false,
        value: value,
      };
    }
    return INVALID_STRING;
  },

  business_hours(hours: BusinessHours) {
    for (const { open, close, h24 } of hours) {
      if (!h24 && !open) {
        return { error: "One of your time slots is missing an opening time. Please ensure all your hours are set" };
      }
      else if (!h24 && !close) {
        return { error: "One of your time slots is missing a closing time. Please ensure all your hours are set" };
      }
      else if (!h24 && (!open.match(/^[0-2][0-9]:[0-5][0-9]$/) || !close.match(/^[0-2][0-9]:[0-5][0-9]$/))) {
        return { error: "One of your time slots has an invalid opening time. Ensure your opening hours are set in 24H format between 00:00 and 23:59" };
      }
    }
    return { error: "" };
  },

};
